import { map } from 'lodash-es'

import languagesObject from '../../i18n/messages'

const specialLanguageCodes = {
  pdc: 'en',
  ja_easy: 'ja',
  zh_Hant: 'zh-HANT',
  zh: 'zh-Hans',
}

const internalToBrowserLocale = (code) => specialLanguageCodes[code] || code

const internalToBackendLocale = (code) =>
  internalToBrowserLocale(code).replace('_', '-')
const internalToBackendLocaleMulti = (codes) => {
  const langs = Array.isArray(codes) ? codes : [codes]
  return langs.map(internalToBackendLocale).join(',')
}

// Each interface language named in itself. A fixed list: browsers ship
// different locale data, so Intl.DisplayNames can answer in English.
const LANGUAGE_NAMES = {
  ar: 'العربية',
  ca: 'català',
  cs: 'čeština',
  de: 'Deutsch',
  en: 'English',
  eo: 'Esperanto',
  es: 'español',
  et: 'eesti',
  eu: 'euskara',
  fi: 'suomi',
  fr: 'français',
  ga: 'Gaeilge',
  he: 'עברית',
  hu: 'magyar',
  it: 'italiano',
  ja: '日本語',
  ja_easy: 'やさしいにほんご',
  ko: '한국어',
  'nan-TW': '臺語（閩南語）',
  nb: 'norsk bokmål',
  nl: 'Nederlands',
  oc: 'occitan',
  pdc: 'Pennsilfaanisch-Deitsch',
  pl: 'polski',
  pt: 'português',
  ro: 'română',
  ru: 'русский',
  sk: 'slovenčina',
  te: 'తెలుగు',
  uk: 'українська',
  zh: '简体中文',
  zh_Hant: '繁體中文',
}

const getLanguageName = (code) => {
  const languageName = LANGUAGE_NAMES[code] ?? code
  const browserLocale = internalToBrowserLocale(code)
  return (
    languageName.charAt(0).toLocaleUpperCase(browserLocale) +
    languageName.slice(1)
  )
}

const languages = map(languagesObject.languages, (code) => ({
  code,
  name: getLanguageName(code),
})).sort((a, b) => a.name.localeCompare(b.name))

const localeService = {
  internalToBrowserLocale,
  internalToBackendLocale,
  internalToBackendLocaleMulti,
  languages,
  getLanguageName,
}

export default localeService
